import { useEffect, useState } from "react";
import { FPaquetesStyle } from "./styles";
import { catCiudad } from "../../../constant/catCiudad"
import {
  Grid,
  Button,
} from "@material-ui/core";
import TablaRegistro from "./TablaRegistro";
import BackDrop from "./../../../global/BackDrop";
import { useDispatch, useSelector } from "react-redux";
import AltaExtra from "./AltaExtra";
import HeaderModal from "../../../global/headerModal";
import ModalBase from "../../../global/ModalBase";
import { closeModalExtrasPaqueteTerrestre, obtenerExtrasPaqueteTerrestre } from "../../../ducks/proveedorTerrestreDuck";

const FPaquetesExtras = (props) => {
  const dispatch = useDispatch();
  const { paqueteSelect, openExtraTerrestre } = useSelector((store) => store.proveedorTerrestre);
  
  const classes = FPaquetesStyle();
  const [isLoad, setIsload] = useState(false);
  
  useEffect(() => {
    setIsload(true);
    dispatch(obtenerExtrasPaqueteTerrestre({idPaqueteTerrestre: paqueteSelect?.IdPaqueteProveedorTerrestre})).then(
      (Response) => {
        setIsload(false);
      }
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paqueteSelect?.IdPaqueteProveedorTerrestre]);

  const handleClose = () => {
    dispatch(closeModalExtrasPaqueteTerrestre())
  };

  return (
    <ModalBase classes={classes} open={openExtraTerrestre} onClose={handleClose}>
      <HeaderModal
        titulo={`Extras para el paqute ${paqueteSelect?.Nombre}`}
        handleClose={handleClose}
      />
      <Grid container className={classes.containerSpacing}>
        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", margin: "10px" }}
        >
          <AltaExtra 
            origen={{ IdCiudad: catCiudad.NO_APLICA }} 
            IdPaquete={paqueteSelect?.IdPaqueteProveedorTerrestre} 
            Moneda={paqueteSelect?.Moneda ? `${paqueteSelect?.Moneda.Clave}` : ""} 
          />
        </Grid>
        <Grid item xs={12}>
          <TablaRegistro />
        </Grid>
      </Grid>
      <Grid container className={classes.containerSpacing}>
        <Grid item xs={12} className={classes.modalBotonesCenter}>
          <Button
            onClick={handleClose}
            variant="contained"
            color="primary"
            className={classes.modalBoton}
          >
            Aplicar
          </Button>
        </Grid>
      </Grid>
      <BackDrop open={isLoad} />
    </ModalBase>
  );
};
export default FPaquetesExtras;
